const empty = () =>
  import(/* webpackChunkName: "empty" */ "../views/Empty.vue");

export default [
  {
    path: "setting",
    name: "Setting",
    component: empty,
    children: [
      {
        path: "catagory",
        name: "GlobalCatagory",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/Catagory.vue"
          ),
        meta: {
          title: "全局菜单",
          root: true,
        },
      },
      {
        path: "bottom",
        name: "SettingBottom",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/set/Bottom.vue"
          ),
        meta: {
          title: "底部导航",
          root: true,
        },
      },
      {
        path: "website",
        name: "SettingWebSite",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/set/WebSite.vue"
          ),
        meta: {
          title: "网站设置",
          root: true,
        },
      },
      {
        path: "app_settings",
        name: "SettingApp",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/set/AppSettings.vue"
          ),
        meta: {
          title: "App设置",
          root: true,
        },
      },

      {
        path: "SensitiveWords",
        name: "SensitiveWords",
        component: () =>
          import(
            /* webpackChunkName: "operation" */ "../views/operation/sensitiveWords/SensitiveWords.vue"
          ),
        meta: {
          title: "敏感词管理",
          root: true,
        },
      },
      {
        path: "sensitiveWords-imports",
        name: "SensitiveWordsImports",
        component: () =>
          import(/* webpackChunkName: "user" */ "../views/Imports"),
        meta: {
          title: "批量导入",
        },
      },
      {
        path: "help",
        name: "SettingHelp",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/set/Help.vue"
          ),
        meta: {
          title: "帮助中心",
          root: true,
        },
      },
      {
        path: "contact",
        name: "SettingContact",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/set/Contact.vue"
          ),
        meta: {
          title: "联系我们",
          root: true,
        },
      },
      {
        path: "about",
        name: "SettingAbout",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/set/About.vue"
          ),
        meta: {
          title: "关于我们",
          root: true,
        },
      },
      {
        path: "account",
        name: "SettingAccount",
        component: () =>
          import(
            /* webpackChunkName: "setting" */
            "../views/setting/promission/Account.vue"
          ),
        meta: {
          title: "账号管理",
          keepAlive: true,
          root: true,
        },
      },
      {
        path: "account/edit",
        name: "AccountEdit",
        component: () =>
          import(
            /* webpackChunkName: "setting" */
            "../views/setting/promission/AccountEdit.vue"
          ),
        meta: {
          title: "账号编辑/新增",
        },
      },
      {
        path: "role",
        name: "SettingRole",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/promission/Role.vue"
          ),
        meta: {
          title: "角色管理",
          root: true,
        },
      },
      {
        path: "role-edit",
        name: "RoleEdit",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/promission/RoleEdit.vue"
          ),
        meta: {
          title: "角色编辑/新增",
        },
      },
      {
        path: "attribute",
        name: "SettingAttribute",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/attribute/Attribute.vue"
          ),
        meta: {
          title: "属性管理",
          root: true,
        },
      },
      {
        path: "attr-manager",
        name: "AttrManager",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/attribute/AttrManager.vue"
          ),
        meta: {
          title: "属性值管理",
        },
      },
      {
        path: "account-new",
        name: "SettingAccountNew",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/AccountNew.vue"
          ),
        meta: {
          title: "账号设置",
          root: true,
        },
      },
      {
        path: "login-record",
        name: "LoginRecord",
        component: () =>
          import(
            /* webpackChunkName: "setting" */ "../views/setting/LoginRecord.vue"
          ),
        meta: {
          title: "登录日志",
          root: true,
        },
      },
    ],
  },
];
